import styled from 'styled-components';
import { Table, Modal } from 'react-bootstrap';

// Vendor Priority Modal styled components
export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }
    
    .odds-value {
        font-weight: bold;
        color: #337ab7;
    }

    .zero-value {
        color: #777;
    }
    
    .edit-button {
        color: white;
    }
`;

export const SectionTitle = styled.h3`
    color: #337ab7;
    margin-top: 20px;
    margin-bottom: 15px;
    font-weight: 500;
`;

export const ModalHeader = styled.div`
    background-color: #f5f5f5;
    padding: 15px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
    
    h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
    }
    
    p {
        margin: 10px 0 0;
        color: #666;
    }
`;

// Edit Distribution Modal styled components
export const SliderContainer = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const SliderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const SliderLabel = styled.div`
  width: 120px;
  font-weight: 500;
`;

export const SliderValue = styled.div`
  width: 60px;
  text-align: center;
  font-weight: bold;
  color: #337ab7;
`;

export const SliderInput = styled.input`
  flex: 1;
  margin: 0 10px;
`;

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #eee;
  font-weight: bold;
`;

export const TotalLabel = styled.div`
  width: 120px;
`;

export const TotalValue = styled.div<{ isValid: boolean }>`
  width: 60px;
  text-align: center;
  color: ${props => props.isValid ? '#5cb85c' : '#d9534f'};
`;

export const CenteredModal = styled(Modal)`
  .modal-dialog {
    margin-top: 10vh;
  }
`;